import { render, staticRenderFns } from "./own-gateways.vue?vue&type=template&id=df390dfa&scoped=true"
import script from "./own-gateways.vue?vue&type=script&lang=js"
export * from "./own-gateways.vue?vue&type=script&lang=js"
import style0 from "./own-gateways.vue?vue&type=style&index=0&id=df390dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df390dfa",
  null
  
)

export default component.exports